import { Field, Label, Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'
import ChevronDown from 'public/assets/chevron-down-primary.svg'
import { FieldValues, useController, UseControllerProps } from 'react-hook-form'
import ErrorMessage from '../ErrorMessage/ErrorMessage'
import styles from './Dropdown.module.scss'

type DropdownProps = UseControllerProps<FieldValues> & {
  label?: string
  options: string[]
}

const Dropdown = ({ control, name, rules, label, options }: DropdownProps) => {
  const {
    field: { onChange: fieldOnChange, value: fieldValue },
    fieldState: { error },
  } = useController({ control, name, rules })

  return (
    <Field className={styles.container}>
      <Listbox value={fieldValue ? fieldValue : ''} onChange={fieldOnChange}>
        <ListboxButton as='div' className={styles.button + (fieldValue ? ' ' + styles.selected : '')}>
          {fieldValue}
          <ChevronDown />
        </ListboxButton>
        <ListboxOptions className={styles.menu} style={{ width: 'var(--button-width)' }} anchor='bottom'>
          {options.map((opt) => (
            <ListboxOption key={opt} value={opt} className={styles.option}>
              {opt}
            </ListboxOption>
          ))}
        </ListboxOptions>
      </Listbox>
      <Label className={fieldValue && styles.elevated}>{label}</Label>
      <ErrorMessage error={error} />
    </Field>
  )
}

export default Dropdown
